import { RouteLocationNormalized } from 'vue-router';

import { usePermissionsStore } from '@/stores';

export async function permissionsMiddleware(to: RouteLocationNormalized) {
  if (to.meta.permission) {
    const permissionsStore = usePermissionsStore();

    if (!permissionsStore.currentUserPermissions) {
      await permissionsStore.getCurrentPermissions();
    }

    if (!permissionsStore.hasPermission(to.meta.permission as string)) {
      return { name: 'not-found' };
    }
  }
}
